/**
 * Páginas de "centro de conocimiento" (conocimiento/*). El texto de cada una
 * (eyebrow/title/description/lead/sections) vive en i18n bajo `authority.pages.<slug>`.
 * Aquí solo se conservan el path (para enrutamiento/SEO) y las fuentes
 * (nombres de instituciones y URLs oficiales, sin traducir).
 */
export const AUTHORITY_PAGES = {
    "ia-sms-seguridad-operacional": {
        path: "/conocimiento/ia-sms-seguridad-operacional",
        sources: [
            ["ICAO — Safety Management Implementation", "https://www.icao.int/safety-management/SMI"],
            ["ICAO — Safety Management Manual, Chapter 9", "https://www.icao.int/safety-management/SMI/SMM/Chapter%209"],
        ],
    },
    "rag-documentacion-aeronautica": {
        path: "/conocimiento/rag-documentacion-aeronautica",
        sources: [["ICAO — Safety Management Guidance Material", "https://www.icao.int/safety-management/guidance-material"]],
    },
    "ia-reportes-seguridad-operacional": {
        path: "/conocimiento/ia-reportes-seguridad-operacional",
        sources: [["ICAO — Safety Management", "https://www.icao.int/safety-management"]],
    },
    "factores-humanos-inteligencia-artificial": {
        path: "/conocimiento/factores-humanos-inteligencia-artificial",
        sources: [["EASA — Artificial Intelligence Roadmap", "https://www.easa.europa.eu/en/domains/research-innovation/ai"]],
    },
    "ciberseguridad-aeronautica": {
        path: "/conocimiento/ciberseguridad-aeronautica",
        sources: [
            ["ICAO — Aviation Cybersecurity Strategy", "https://www.icao.int/aviation-cybersecurity/strategy"],
            ["ICAO — Cybersecurity Action Plan", "https://www.icao.int/aviation-cybersecurity/action-plan"],
        ],
    },
    "ia-operaciones-criticas": {
        path: "/conocimiento/ia-operaciones-criticas",
        sources: [
            ["FAA — Roadmap for AI Safety Assurance", "https://www.faa.gov/aircraft/air_cert/step/roadmap_for_AI_safety_assurance"],
            ["EASA — Artificial Intelligence", "https://www.easa.europa.eu/en/domains/research-innovation/ai"],
        ],
    },
};

/**
 * Casos de estudio (casos/*). El texto de cada uno vive en i18n bajo
 * `authority.cases.<slug>`.
 */
export const CASE_STUDIES = {
    campoconecta: {
        path: "/casos/campoconecta",
        sources: [["CampoConecta en Google Play", "https://play.google.com/store/apps/details?id=com.emmpieza.tuappagricolamarket"]],
    },
    "analisis-presidencial-colombia-2026": {
        path: "/casos/analisis-presidencial-colombia-2026",
        sources: [["Análisis Presidencial CO 2026 en Google Play", "https://play.google.com/store/apps/details?id=com.emmpieza.radarpresidencial"]],
    },
    "scanner-django-vsecuritycode": {
        path: "/casos/scanner-django-vsecuritycode",
        sources: [["Código del proyecto en GitHub", "https://github.com/3p1c0w3nd/extension-vs-scan-vuln-django"]],
    },
};

/** Enlaces (path + slug) del clúster de aviación; el texto se resuelve vía i18n en el consumidor. */
export const AVIATION_CLUSTER_LINKS = Object.entries(AUTHORITY_PAGES).map(([slug, { path }]) => ({ slug, path }));
